import React, { useEffect, useContext, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import NavButtons from '../../common/NavButtons';
import { CustomModalContext } from '../../contexts/CustomModalContext';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { LoadingAnimationContext } from '../../contexts/LoadingAnimationContext';
import {
    queryShipment,
    getDriverActivePrecheck,
    getDriverByPhoneNumber
} from '../../services/APIs';
import { FormattedMessage } from 'react-intl';
import LiveLoad from './LiveLoad';
import PreLoad from './PreLoad';

const visitTypeList = [
    { label: 'Live Load', value: 'LL' },
    { label: 'Preload', value: 'PL' }
];

const DriverInfoEntry = () => {
    const { precheckInfo, setPrecheckInfo, orderInfo, setOrderInfo } = useContext(PrecheckContext);
    const { showModal, showNetworkErrorModal, showInvalidUrlModal } =
        useContext(CustomModalContext);
    const { setShowLoading } = useContext(LoadingAnimationContext);
    const Navigate = useNavigate();

    const onSubmit = async () => {
        
        const { submittedPhoneNumber, submittedReferenceId, plantId,submittedDotNumber } = precheckInfo;

        // Check Manhattan for order associated with submittedReferenceId (delivery, trip, PO)
        const orderResponse = await queryShipment(
            submittedPhoneNumber,
            submittedReferenceId,
            plantId
        );
        if (orderResponse?.data?.order) {
            const onOrderConfirm = () => {
                const {
                    deliveryId,
                    customerPO,
                    shipmentId,
                    visitType,
                    carrierName,
                    carrierSCAC,
                    address,
                    customerName,
                    pickupAppointment,
                    deliveryAppointment
                } = orderResponse.data.order;

                setOrderInfo({
                    ...orderInfo,
                    manhDeliveryId: deliveryId,
                    manhCustomerPo: customerPO,
                    manhTripId: shipmentId,
                    manhVisitType: visitType,
                    manhCarrierName: carrierName,
                    manhCarrierSCAC: carrierSCAC,
                    manhAddress: address,
                    manhCustomerName: customerName,
                    manhPickupAppointment: pickupAppointment,
                    manhDeliveryAppointment: deliveryAppointment
                });
                setPrecheckInfo({ ...precheckInfo, isOrderFound: true });
            };

            const onOrderReject = () => {
                showModal({
                    title: 'Notice',
                    subtitle:
                        'Okay, a Niagara team member will locate your order momentarily. Please continue.',
                    buttonOneText: 'Continue'
                });
            };

            const foundOrderData = orderResponse?.data;
            showModal({
                title: 'Confirm Order Destination',
                subtitle: (
                    <>
                        <span>Is this the correct information</span>
                        <br />
                        <br />
                        <span>{foundOrderData.order.address}</span>
                        <br />
                        <br />
                        <span>{foundOrderData.order.customerName}</span>
                    </>
                ),
                buttonOneText: 'Reject',
                buttonTwoText: 'Confirm',
                buttonOneAction: onOrderReject,
                buttonTwoAction: onOrderConfirm,
                twoButtons: true
            });
        }

        Navigate('/TAC');
    };

    const checkForSavedPhoneNumber = () => {
        const savedPhoneNumber = localStorage.getItem('phoneNumber');
        if (savedPhoneNumber) {
            setPrecheckInfo({ ...precheckInfo, submittedPhoneNumber: savedPhoneNumber });
        }
    };

    const checkForActivePrecheck = async () => {
        const cachedNumber = localStorage.getItem('phoneNumber') || '';

        const phoneNumberWithCountryCode =
            cachedNumber.length < 11 ? `1${cachedNumber}` : cachedNumber;
        const precheckResponse = await getDriverActivePrecheck(phoneNumberWithCountryCode);
        if (precheckResponse.data.precheck) {
            setPrecheckInfo({
                ...precheckInfo,
                ...precheckResponse.data.precheck
            });
            Navigate('/report');
        }
    };

    const getDriver = async () => {
        const phoneNumber = localStorage.getItem('phoneNumber') || '';
        const phoneNumberWithCountryCode =
            phoneNumber.length < 11 ? `1${phoneNumber}` : phoneNumber;
        const response = await getDriverByPhoneNumber(phoneNumberWithCountryCode);

        if (response.data.driver) {
            setPrecheckInfo({
                ...precheckInfo,
                submittedName: response.data.driver.name,
                submittedPhoneNumber: response.data.driver.phoneNumber
            });
        }
    };

    useEffect(() => {
        setShowLoading(true);
        checkForActivePrecheck();
        getDriver();
        checkForSavedPhoneNumber();
    }, []);

    return (
        <>
            <div className="body-container driver-info-entry">
                <p className="form-title m-4 text-center">
                    <FormattedMessage
                        id="driverInfoEntryTitle"
                        defaultMessage="Driver Information"
                    />
                </p>
                <form className="d-flex flex-column flex-wrap px-4">
                    <label className="mb-2">
                        <FormattedMessage
                            id="driverInfoEntryInputLabelOrderType"
                            defaultMessage="Order Type"
                        />
                    </label>
                    <div className="check-box-wrapper d-flex">
                        {visitTypeList.map((vistType: { label: string; value: string }) => {
                            return (
                                <div className="form-check" key={vistType.value}>
                                    <input
                                        className="form-check-input"
                                        type="radio"
                                        name="orderType"
                                        id={`vistType-${vistType.value}`}
                                        hidden
                                        checked={precheckInfo.submittedVisitType === vistType.value}
                                        onChange={(e) =>
                                            setPrecheckInfo({
                                                ...precheckInfo,
                                                submittedVisitType:
                                                    e.target.value === 'LL' ? 'LL' : 'PL'
                                            })
                                        }
                                        value={vistType.value}
                                    />
                                    <label
                                        className="form-check-label"
                                        htmlFor={`vistType-${vistType.value}`}>
                                        {vistType.label}
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                    {precheckInfo.submittedVisitType === 'LL' ? <LiveLoad /> : <PreLoad />}
                </form>
                <NavButtons
                    nextButtonAction={onSubmit}
                    nextText={<FormattedMessage id="submit" defaultMessage="Submit" />}
                    previous={false}
                    nextButtonDisabled={
                        precheckInfo.submittedName.length === 0 ||
                        precheckInfo.submittedPhoneNumber.length === 0 ||
                        precheckInfo.submittedReferenceId.length === 0 ||
                        (precheckInfo.submittedTrailerNumber.length === 0 &&
                            precheckInfo.hasTrailer)
                    }
                />
            </div>
        </>
    );
};

export default DriverInfoEntry;
